export const ROUTES = {
  SESSIONS: {
    SESSION: "/sessions/:sessionId",
  },
  PAGES: {
    MAINTENANCE: "/pages/maintenance",
    SSO_SETUP: "/pages/sso-setup",
  },
  AUTH: {
    SIGNUP: "/signup",
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    ERROR: "/auth/error",
    REDIRECT: "/auth/redirect",
  },
  INVITE: "/invite",
  /** Shown after a valid beta code, before Auth0 signup */
  INVITE_CONTINUE: "/invite/continue",
  ONBOARDING: {
    ROOT: "/onboarding",
    CREATE_ORGANIZATION: "/onboarding/create-organization",
    /** Transient: silently provisions the org for a self-serve or template signup, then lands home. */
    SETUP: "/onboarding/setup",
    SELECT_PLAN: "/onboarding/select-plan",
    ENTERPRISE_INQUIRY: "/onboarding/enterprise-inquiry",
    CHECKOUT: "/onboarding/checkout",
    CONFIRM_SETUP: "/onboarding/confirm-setup",
  },
  HOME: "/",
  /** Mobile-only (native) screens: focused home + dictation. */
  MOBILE: {
    HOME: "/m",
    VOICE: "/m/voice",
  },
  /**
   * Manage-modal deep links. Paths are intent-addressed — each one opens the
   * modal on a tab, landed on a scope (see `components/ManageModal`). The
   * legacy block below keeps retired links (and Stripe checkout round-trips)
   * resolving to their successor scope.
   */
  SETTINGS: {
    ROOT: "/settings",
    PROFILE: "/settings/profile",
    PREFERENCES: "/settings/preferences",
    ORGANIZATION: "/settings/organization",
    MEMBERS: "/settings/members",
    GROUPS: "/settings/groups",
    CONNECTORS: "/settings/connectors",
    CONNECTORS_SETTINGS: "/settings/connectors/:integrationId",
    USAGE: "/settings/usage",
    USAGE_BILLING: "/settings/usage/billing",
    ARCHIVE: "/settings/archive",

    // Retired paths — still land on their successor scope.
    MY_SETTINGS: "/settings/my-settings",
    USERS: "/settings/users",
    AUDIO: "/settings/audio",
    IDENTITY_PROVISIONING: "/settings/sso",
    USAGE_BILLING_LEGACY: "/settings/usage-billing",
  },
  BILLING: {
    ROOT: "/billing",
    CHECKOUT: "/billing/checkout",
    CONFIRM_SETUP: "/billing/confirm-setup",
    PLANS: "/billing/plans",
    ENTERPRISE_INQUIRY: "/billing/enterprise-inquiry",
  },
  SKILLS: {
    ROOT: "/skills",
    SHOW: "/skills/:id",
  },
  SKILL_TEMPLATES: {
    ROOT: "/skill-templates",
    SHOW: "/skill-templates/:id",
  },
  AUTOMATIONS: {
    ROOT: "/automations",
    NEW: "/automations/new",
    SHOW: "/automations/:id",
  },
  ENTITIES: {
    DETAIL: "/entity/:platform/:entityId",
    LIST: "/entities/:flowSessionId/:flowMessageId",
  },
  FILE_RECORDS: {
    DETAIL: "/file-record/:fileRecordId",
  },
  CANVAS: {
    ROOT: "/canvas",
    /**
     * Transient shell while a create is in flight — the id does not exist yet.
     * Replaced by DETAIL as soon as the response lands, so it is never a
     * history entry Back can return to. Deliberately not under `/canvas/`:
     * `useMatch(DETAIL)` matches any single segment, and a dozen always-mounted
     * components would read "new" as a canvas id and fetch it.
     */
    NEW: "/canvas-new",
    DETAIL: "/canvas/:canvasId",
  },
  CHAT: {
    DETAIL: "/chat/:flowSessionId",
  },
  CANVAS_EXPERIMENTS: {
    NOTION_DETAIL: "/canvas-experiments/notion/:pageId",
    EMAIL_DETAIL: "/canvas-experiments/email/:emailId",
  },
  GITHUB: {
    ISSUE_DETAIL: "/github/issue/:issueId",
    PR_DETAIL: "/github/pr/:prId",
    REPO_DETAIL: "/github/repo/:repoId",
    PROJECT_DETAIL: "/github/project/:projectId",
  },
  GOOGLE_DRIVE: {
    FILE_DETAIL: "/google-drive/file/:fileId",
  },
  GOOGLE_CALENDAR: {
    EVENT_DETAIL: "/google-calendar/event/:eventId",
  },
  SLACK: {
    MESSAGE_DETAIL: "/slack/message/:messageId",
  },
  GRANOLA: {
    MEETING_DETAIL: "/granola/meeting/:meetingId",
  },
  WORKSPACES: {
    ROOT: "/workspaces",
    DETAIL: "/workspaces/:workspaceId",
  },

  // Everything "deleted" is archived (restorable), so the surface is Archived.
  ARCHIVE: {
    ROOT: "/archive",
    /** Legacy path — redirects to ROOT so old links keep working. */
    LEGACY_TRASH: "/trash",
  },

  SHARED: {
    ROOT: "/shared",
  },
};
